import React from 'react';

import storage from '@api/storage';
import { logout } from '@features/loginSlice';
import EmailTemplates from '@routes/EmailTemplates';
import Emails from '@routes/Emails';
import Forms from '@routes/Forms';
import LandingPageTemplates from '@routes/LandingPageTemplates';
import LandingPages from '@routes/LandingPages';
import Login from '@routes/Login';
import NewOrderEmailTemplates from '@routes/NewOrder/NewOrderEmailTemplates';
import NewOrderEmails from '@routes/NewOrder/NewOrderEmails';
import NewOrderForms from '@routes/NewOrder/NewOrderForms';
import NewOrderLandingPageTemplates from '@routes/NewOrder/NewOrderLandingPageTemplates';
import NewOrderLandingPages from '@routes/NewOrder/NewOrderLandingPages';
import NewOrderPrograms from '@routes/NewOrder/NewOrderPrograms';
import NewOrderSnippets from '@routes/NewOrder/NewOrderSnippets';
import NotFound from '@routes/NotFound';
import OrdersSuccess from '@routes/OrdersSuccess';
import Programs from '@routes/Programs';
import Snippets from '@routes/Snippets';
import { ROUTES } from '@routes/constants';
import { useAppDispatch } from '@store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Route, Routes } from 'react-router';
import { BrowserRouter, redirect } from 'react-router-dom';

import Layout from '@components/Layout';

function App() {
  const dispatch = useAppDispatch();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000000,
        onSettled: () => {
          // check if the token expired
          if (storage.isTokenExpired()) {
            dispatch(logout('The session expired'));
            redirect(ROUTES.LOGIN);
          }
        },
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path={ROUTES.LOGIN} element={<Login />} />
          <Route path={'/'} element={<Layout />}>
            <Route index element={<Programs />} />
            <Route path={ROUTES.EMAIL_TEMPLATES} element={<EmailTemplates />} />
            <Route path={ROUTES.EMAILS} element={<Emails />} />
            <Route path={ROUTES.FORMS} element={<Forms />} />
            <Route path={ROUTES.LANDING_PAGES_TEMPLATES} element={<LandingPageTemplates />} />
            <Route path={ROUTES.LANDING_PAGES} element={<LandingPages />} />
            <Route path={ROUTES.SNIPPETS} element={<Snippets />} />
            <Route path={ROUTES.ORDERS_PROGRAMS} element={<NewOrderPrograms />} />
            <Route path={ROUTES.ORDERS_EMAIL_TEMPLATES} element={<NewOrderEmailTemplates />} />
            <Route path={ROUTES.ORDERS_EMAILS} element={<NewOrderEmails />} />
            <Route path={ROUTES.ORDERS_FORM} element={<NewOrderForms />} />
            <Route path={ROUTES.ORDERS_LANDING_PAGE_TEMPLATES} element={<NewOrderLandingPageTemplates />} />
            <Route path={ROUTES.ORDERS_LANDING_PAGES} element={<NewOrderLandingPages />} />
            <Route path={ROUTES.ORDERS_SNIPPETS} element={<NewOrderSnippets />} />
            <Route path={ROUTES.ORDERS_SUCCESS} element={<OrdersSuccess />} />
            <Route path={ROUTES.PROGRAMS} element={<Programs />} />
            <Route path={'/*'} element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
